//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText } = require('core/i18n').i18n;
const moment = require('moment');

// @components
import DateFilter from 'components/commons/filters/filters/dateFilter';
import RadioFilter from 'components/commons/filters/filters/radioFilter';
import CheckFilter from 'components/commons/filters/filters/checkFilter';
import Filters from 'components/commons/filters/filters';

// @constants
const { PFM_FILTERS } = require('constants/index');
const { CREDIT_MOVEMENTS, DEBIT_MOVEMENTS, ALL_MOVEMENTS } = require('constants/expensesByCategories/filters');
const DATE_FILTER_MIN_DATE_LIMIT = moment().startOf('day').subtract(1, 'years');
const { DATE, CONTRACT_TYPE, CUSTOM_ACCOUNTS} = require('constants/expensesByCategories/filters');

class ExpensesByCategoryFilter extends React.Component {

    constructor(props) {
        super(props);
    }

    getContractOptions = () => ([{
        label: formatText('aggregatorMovementsFilter-allMovements'),
        value: ALL_MOVEMENTS
    }, {
        label: formatText('groupContractFilter-debitContract'),
        value: DEBIT_MOVEMENTS
    }, {
        label: formatText('groupContractFilter-creditContract'),
        value: CREDIT_MOVEMENTS
    }])

    render() {
        const { onFilter, onClearFilter, onOpenModal, hasCreditCardCountry } = this.props;
        const optionsContract = !hasCreditCardCountry ? this.getContractOptions().slice(0, -1) : this.getContractOptions();

        return (
            <Filters
                filtersId={PFM_FILTERS}
                title="referrals-filtersTitle"
                onFilter={onFilter}
                onCloseModal={onClearFilter}
                onOpenModal={onOpenModal}
            >
                <h5 className="account-debits-header__filter-subtitle">
                    <FormattedText value="accountDebitsFilter-date" />
                </h5>
                <div>
                    <DateFilter
                        filterId={DATE}
                        minDate={DATE_FILTER_MIN_DATE_LIMIT}
                    />
                </div>
                <h5 className="account-debits-header__filter-subtitle">
                    <FormattedText value="typeAccountFilter-title" />
                </h5>
                <div>
                    <CheckFilter
                        filterId={CUSTOM_ACCOUNTS}
                        label={formatText('typeAccountFilter-customAccounts')}
                        initialValue
                    />
                </div>
                <h5 className="account-debits-header__filter-subtitle">
                    <FormattedText value="contractsFilter-title" />
                </h5>
                <div className="filters__checkbox-container">
                    <RadioFilter
                        filterId={CONTRACT_TYPE}
                        initialSelected={'all'}
                        noFilterId={'all'}
                        options={optionsContract}
                    />
                </div>
            </Filters>
        );
    }
}

ExpensesByCategoryFilter.propTypes = {
    onFilter: PropTypes.func.isRequired,
    onClearFilter: PropTypes.func.isRequired,
    onOpenModal: PropTypes.func.isRequired,
    hasCreditCardCountry: PropTypes.bool.isRequired
};

module.exports = ExpensesByCategoryFilter;